import moment from "moment";
import {
  COMPETITIONS_API,
  DATE_FORMAT,
  DEFAULT_CURRENCY,
  POPULARCOMPETITIONS_API,
  POPULARTEAMS_API,
  STARTDATE_FORMAT,
  TEAMS_API,
} from "../../constants";

export const SportTypeToShow = (sport) => {
  if (sport === "soccer") {
    return "football";
  } else {
    return sport;
  }
};

export const callAMobileNumber = (mobile_number) => {
  const phoneURI = `tel:${mobile_number}`;
  window.location.href = phoneURI;
};


export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};
export const getRowLengthAccordingToData = (total) => {
  if (total <= 10 && total >= 0) {
    return [10];
  } else if (total >= 10 && total <= 25) {
    return [10, 25];
  } else if (total >= 25 && total <= 50) {
    return [10, 25, 50];
  } else if (total >= 50) {
    return [10, 25, 50, 100];
  }
};

export const ctgUnderscoreRemoverfucntion = (input) => {
  if (input) {
    return input.replace(/^_/, "")
  }
  return ""
}

export const ChangeSportTypeforApi = (selectedSport) => {
  if (selectedSport == "football") {
    return "soccer";
  } else if (selectedSport == "motorsport") {
    return "Formula1";
  } else {
    return selectedSport;
  }
};

export const formatDate = (date) => {
  return moment.parseZone(date).format(DATE_FORMAT);
};

export const userSelectedDate = (date) => {
  return moment(new Date(date)).format(STARTDATE_FORMAT);
};

export const chipDateShow = (firstdate, secondDate) => {
  if (firstdate && secondDate) {
    const StartDateYear = moment(firstdate).format("YYYY");
    const EndDateYear = moment(secondDate).format("YYYY");
    const StartDateMonth = moment(firstdate).format("MMMM");
    const EndDateMonth = moment(secondDate).format("MMMM");
    if (StartDateYear === EndDateYear) {
      if (StartDateMonth === EndDateMonth) {
        return `${moment(firstdate).format("MMM D")}-${moment(
          secondDate
        ).format("D, YYYY")}`;
      } else {
        return `${moment(firstdate).format("MMM D")}-${moment(
          secondDate
        ).format("MMM D, YYYY")}`;
      }
    } else {
      return `${moment(firstdate).format("MMM D, YYYY")}-${moment(
        secondDate
      ).format("MMM D, YYYY")}`;
    }
  } else if (firstdate) {
    return "From " + moment(firstdate).format("MMM D, YYYY");
  } else {
    return "";
  }
};

export const priceRangeShow = (min_Price, max_price) => {
  if (min_Price && max_price) {
    return `${DEFAULT_CURRENCY}${min_Price} - ${DEFAULT_CURRENCY}${max_price}`;
  } else if (min_Price) {
    return `${DEFAULT_CURRENCY}${min_Price} or higher`;
  } else if (max_price) {
    return `${DEFAULT_CURRENCY}0 - ${DEFAULT_CURRENCY}${max_price}`;
  }
};

export const getPopularApiByTabs = (currentSortingTab) => {
  if (currentSortingTab === "Team") {
    return POPULARTEAMS_API;
  }
  //  else if (currentSortingTab === "Competition") {
  //   return POPULARCOMPETITIONS_API;
  // }
  return "";
};

export const getSearchApiByTabs = (currentSortingTab) => {
  if (currentSortingTab === "Team") {
    return TEAMS_API;
  } else if (currentSortingTab === "Competition") {
    return COMPETITIONS_API;
  }
};

export const getCurrentDate = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return userSelectedDate(`${month}/${date}/${year}`);
};

export const RemoveFilter = (index, variable, func) => {
  const filteredOptions = variable.filter((item, ind) => {
    return ind !== index;
  });
  func(filteredOptions);
};

export const getEventYear = (firstDate, secondDate) => {
  return moment(firstDate).format("YY") + "/" + moment(secondDate).format("YY");
};

export const moneyRoundOff = (price) => {
  return Math.floor(price).toLocaleString("en-IN");
};

export const getTime = (firstTime, secondTime) => {
  if (firstTime) {
    return `${moment(firstTime).utcOffset("+05:30").format(`HH:mm`)}`;
  }
  if (firstTime && secondTime) {
    return `${moment(firstTime).utcOffset("+05:30").format(`HH:mm`)} - ${moment(
      secondTime
    )
      .utcOffset("+05:30")
      .format("HH:mm")}`;
  }
};

export const scrollIntoView = (ref) => {
  ref.current?.scrollIntoView({ behavior: "smooth" });
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const totalPriceWithMarkup = (price, markupPercentage, isMarkup) => {

};


export const formatPrice = (amount, isMarkup = false, markupPercentage) => {

  if (isMarkup) {
    const numericPrice = Number(amount) || 0;
    if (numericPrice === 0) {
      return 0;
    }
    const markupToAdd = numericPrice * (markupPercentage / 100);
    const totalWithMarkup = numericPrice + markupToAdd;
    return Number(totalWithMarkup).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });;
  }
  else if (!amount) return 'N/A';

  else return Number(amount).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


export const convertTicketFormat = (day) => {
  if (day === "fri") {
    return "friday";
  }
  if (day === "sat") {
    return "saturday";
  }
  if (day === "sun") {
    return "sunday";
  }
  if (day === "weekend") {
    return `Friday-Sunday`;
  }
  if (day === "satsun") {
    return "Saturday-Sunday";
  } else {
    return day;
  }
};

export const getDayFromDate = (date) => {
  if (date) {
    return moment(date).format("dddd");
  }
};

export const getCrossIcon = (CategoryName, params) => {
  if (CategoryName === "Team") {
    return params.filter((item) => item.key == "team_name");
  }
  if (CategoryName === "Competition") {
    return params.filter((item) => item.key == "tournament_name");
  }
  if (CategoryName === "Location") {
    return params.filter(
      (item) =>
        item.key == "country" || item.key === "venue" || item.key === "city"
    );
  }
  if (CategoryName === "Date") {
    return params.filter(
      (item) => item.key == "date_start" || item.key == "date_stop"
    );
  }
  if (CategoryName === "Price-Range") {
    return params.filter(
      (item) => item.key == "minPrice" || item.key == "maxPrice"
    );
  }
  if (CategoryName === "Availability") {
    return params.filter((item) => item.key == "ticket_Availability");
  }
};

export function formatEventDateRange(from, to) {
  const startDate = new Date(from);
  const endDate = new Date(to);

  const options = { month: 'short', day: 'numeric' };
  const sameMonth = startDate.getMonth() === endDate.getMonth();
  const sameYear = startDate.getFullYear() === endDate.getFullYear();

  if (sameMonth && sameYear) {
    const startDay = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(startDate);
    const endDay = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(endDate);
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(startDate);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(startDate);
    return `${month} ${startDay}—${endDay}, ${year}`;
  } else {
    const startFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(startDate);
    const endFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(endDate);
    return `${startFormat} — ${endFormat}`;
  }
}